export default __webpack_public_path__ + "media/images/work_with_us/team-pic-3-7b96c69913b4574dd57ff23b83a4fba2.png";